import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, Alert, TableHead, TableRow, 
  Paper, TableSortLabel, Checkbox, Snackbar, Box, TablePagination, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { useSelectedRows } from './SelectedRowsContext';
import EditIcon from '@mui/icons-material/Edit';
import ModalUpdate from "../modales/ModalUpdate";
import { styleTableCell } from "../../estilo/Main"
import { styleScrollH } from "../../estilo/modal"

const HIDDEN_COLUMNS = ['Estado', 'id_cliente', 'procedimiento', 'id', 'id_doc_subido', 'id_doc_procesado', 'id_doc_factura', 'id_codigo_factura',
  'id_contestacion', 'id_contestacion_agrupada', 'numero_egreso', 'numero_radicado', 'id_codigo_esp', 'id_codigo_gen', 'id_doc_contestacion', 'amparo', 'almacenado', 'fecha_aviso', 'fecha_ingreso', 'fecha_liquidacion', 'fecha_formalizacion', 'fecha_recepcion', 'fecha_siniestro',];

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': { color: '#30765e' },
  '& .MuiSvgIcon-root': { borderRadius: '50%' },
}));

const StyledCheckbox2 = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': { color: 'black' },
  '& .MuiSvgIcon-root': { borderRadius: '50%' },
}));

const DataTable = ({ data, refreshKey, tabla }) => {
  const { selectedRows, setSelectedRows } = useSelectedRows();
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(150);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState('');
  const [orderDirection, setOrderDirection] = useState('asc');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [dataSelected, setDataSelected] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  var tabla_actual = '';
  const labelMap = {
    amparo: 'Amparo',
    almacenado: 'Almacenado',
    Carpeta_Origen: 'Ubicación',
    carpeta_origen: 'Ubicación',
    codigo_ciudad: 'Código de la ciudad',
    contenido_archivos: 'Contenido del soporte',
    diagnostico: 'Diagnóstico',
    id: 'ID',
    id_doc_subido: 'ID Subido',
    id_doc_procesado: 'ID Procesado',
    factura_rd: 'Código glosa',
    fecha_aviso: 'Fecha de aviso',
    Fecha_Ingreso: 'Fecha de ingreso',
    Fecha_ingreso: 'Fecha de ingreso',
    fecha_ingreso: 'Fecha de ingreso',
    fecha_liquidacion: 'Fecha de liquidación',
    fecha_formalizacion: 'Fecha de formalización',
    fecha_recepcion: 'Fecha de formalización',
    fecha_siniestro: 'Fecha del siniestro',
    Nombre_archivo: 'Nombre del archivo',
    nombre_archivo: 'Nombre del archivo',
    nombre_cliente: 'Cliente',
    nit_reclamante: 'NIT del reclamante', 
    nombre_reclamante: 'Nombre del reclamante', 
    numero_egreso: 'Número de egreso', 
    numero_factura: 'Código de glosa', 
    numero_radicado: 'Número de radicado', 
    objecion: 'Objeción', 
    pago_neto: 'Pago neto', 
    sucursal: 'Sucursal', 
    valor_total_cobrado: 'Valor total cobrado', 
    vigencia_desde: 'Vigente desde', 
    vigencia_hasta: 'Vigente hasta', 
    cantidad: 'Cantidad', 
    cobrado: 'Cobrado', 
    codigo: 'Código', 
    liquidado: 'Liquidado', 
    observacion: 'Observación', 
    porcentaje: 'Porcentaje', 
    factura: 'Código de glosa', 
    fecha: 'Fecha de generación', 
    cod_esp: 'Código específico', 
    codigo_esp: 'Código específico', 
    cod_gen: 'Código general', 
    codigo_gen: 'Código general',
    contestacion: 'Contestación', 
    formato: 'Formato', 
    id_codigo_factura: 'ID Código glosa', 
    id_doc_factura: 'IDX Glosa', 
    asunto: 'Asunto', 
    mensaje: 'Mensaje', 
    nit: 'NIT', 
    correo: 'Correo', 
    desde: 'Desde', 
    hasta: 'Hasta', 
    aplicacion: 'Aplicación',
    desripcion: 'Descripción',
    desripcion_codigo_esp: 'Descripción'
  };

  const handleSort = (column) => {
    const isAsc = orderBy === column && orderDirection === 'asc';
    setOrderDirection(isAsc ? 'desc' : 'asc');
    setOrderBy(column);
    const sortedRows = [...filteredRows].sort((a, b) => {
      if (isAsc) {
        return a[column] < b[column] ? -1 : 1;
      } else {
        return a[column] > b[column] ? -1 : 1;
      }
    });
    setFilteredRows(sortedRows);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelectedRows([...filteredRows]);
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (row) => {
    console.clear();
    tabla_actual = localStorage.getItem("tact", tabla);
    if (tabla_actual && tabla_actual !== tabla) {
      setSelectedRows([]);
    }
    localStorage.setItem("tact", tabla);
    setSelectedRows((prevSelectedRows) => {
      const alreadySelected = prevSelectedRows.some(
        (selectedRow) => JSON.stringify(selectedRow) === JSON.stringify(row)
      );
      if (alreadySelected) {
        return prevSelectedRows.filter(
          (selectedRow) => JSON.stringify(selectedRow) !== JSON.stringify(row)
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  const handleEdit = (registro) => {
    setDataSelected(registro);
    setOpenEditModal(true);
  };

  const handleCloseModal = () => {
    setOpenEditModal(false);
  };

  useEffect(() => setFilteredRows(data), [data]);

  return (
    <>
    <Box>
      <Paper style={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer style={styleScrollH} component={Paper}>
          <Table key={refreshKey} stickyHeader size="small" style={{ minWidth: 1200 }}>
            <TableHead>
              <TableRow>
                {Object.keys(data[0] || {}).filter((col) => !HIDDEN_COLUMNS.includes(col)).map((column) => (
                  <TableCell key={column} sx={styleTableCell}>
                    <TableSortLabel active={orderBy === column} direction={orderBy === column ? orderDirection : 'asc'} onClick={() => handleSort(column)} >
                      {labelMap[column] || column}
                    </TableSortLabel>
                  </TableCell>
                ))}
                { (localStorage.getItem('view') !== 'procesador' && localStorage.getItem('view') !== 'FacturasRd' &&
                   localStorage.getItem('view') !== 'soportes' && localStorage.getItem('view') !== 'Contestaciones' && 
                   localStorage.getItem('view') !== 'informes') &&
                  <TableCell
                    sx={{padding: '4px',fontSize: '0.8rem',fontWeight: 'bold',textAlign: 'center',verticalAlign: 'middle', color:'white'}}> Modificar
                  </TableCell>
                }
                { (tabla === 'DocumentosSubidos' || tabla === 'FacturasRd' || tabla === 'SoportesSubidos' ||
                  tabla === 'DiccionarioClientes' || tabla === 'DiccionarioCodigoEsp' || tabla === 'DiccionarioCodigoGen'||
                  tabla === 'ContestacionesAgrupadas') &&
                <TableCell sx={{ padding: '4px', fontSize: '0.8rem', fontWeight: 'bold', textAlign: 'center', verticalAlign: 'middle', color:'white'}}> Seleccionar
                  <StyledCheckbox2 indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < filteredRows.length
                    }
                    checked={
                      filteredRows.length > 0 &&
                      selectedRows.length === filteredRows.length
                    }
                    onChange={handleSelectAllClick}
                  />
                </TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={row.id || index}>
                    {Object.entries(row).filter(([key])=> !HIDDEN_COLUMNS.includes(key)).map(([key, value], idx) => (
                      <TableCell key={idx} sx={{padding: '4px', fontSize: '0.8rem', ...((key === 'observacion'|| key === 'contestacion' ||
                         key === 'descripcion_codigo_esp') && {maxHeight: '300px', maxWidth: '300', overflow: 'auto', whiteSpace: 'pre-wrap',
                           textOverflow: 'ellipsis', display: 'flex'})}}>
                        {(localStorage.getItem('view') === 'informes' && key === 'almacenado') ?
                        (value === 1 || value === '1' ? 'SI' : 'NO')
                        :value
                        }
                      </TableCell>
                    ))}
                    { (localStorage.getItem('view') !== 'procesador' && localStorage.getItem('view') !== 'FacturasRd' &&
                       localStorage.getItem('view') !== 'soportes' && localStorage.getItem('view') !== 'Contestaciones' && 
                       localStorage.getItem('view') !== 'informes') &&
                      <TableCell sx={{ textAlign: 'center', padding: '4px' }}>
                        <IconButton aria-label="modify" onClick={() => handleEdit(row)} sx={{ color: 'black' }} >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    }
                    {(tabla === 'DocumentosSubidos' || tabla === 'FacturasRd' || tabla === 'SoportesSubidos' || 
                    tabla === 'DiccionarioClientes' || tabla === 'DiccionarioCodigoEsp' || tabla === 'DiccionarioCodigoGen'||
                    tabla === 'ContestacionesAgrupadas')  &&
                    <TableCell style={{ textAlign: 'center', padding: '4px' }}>
                      <StyledCheckbox
                        onChange={() => handleCheckboxChange(row)}
                        checked={selectedRows.some(
                          (selectedRow) =>
                            JSON.stringify(selectedRow) === JSON.stringify(row)
                        )}
                      />
                    </TableCell>
                    }
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[50, 150, 300]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
            labelRowsPerPage="Filas por página"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{ fontSize: '0.8rem', }}
          />
      </Paper>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <Alert severity="warning">No se puede seleccionar registros con diferentes tipos de notificación.</Alert>
      </Snackbar>
    </Box>
    <ModalUpdate open={openEditModal} handleClose={handleCloseModal} registro={dataSelected} />
    </>
  );
};
export default DataTable;